<template>
  <div :class="wrapperClasses" :id="identifier" v-show="!state.hidden">
    <label class="govuk-label" :for="controlId" v-show="!state.hiddenLabel" v-html="displayName">
    </label>
    <div :id="titleId" class="govuk-title" v-html="displayTitle"></div>

    <div :class="displayHintClasses" v-if="displayHint" v-on:click="toggleHintSection" v-html="displayHintText"></div>
    <div :id="hintId" class="govuk-hint" v-show="!state.hiddenHint" v-html="displayHint"></div>

    <span :id="errorId" class="govuk-error-message" v-show="!state.isValid">
      <ul v-if="currentErrors.length > 0">
        <li v-for="(errorMessage, errIndex) in currentErrors" v-bind:key="errIndex">
          {{ errorMessage.message }}
        </li>
      </ul>
    </span>
    <input
      :id="controlId"
      type="text"
      :name="controlId"
      title=""
      :disabled="state.readOnly"
      v-on:blur="focusOut()"
      :aria-describedby="hintId"
      class="govuk-input"
      v-model="state.value"
    />
  </div>
</template>
<script lang="ts" src="@/library/templates/default/controls/TextBox.ts"></script>
